import { client as clientRoutes } from 'config/routes'

export const GOUSTO_ANYTIME_INTENTS = {
  startOneOffOrder: 'start_one_off_order',
  reactivateSubscription: 'reactivate_subscription',
  editRecipes: 'edit_recipes',
  viewCollection: 'view_collection',
  pastDeliveries: 'past_deliveries',
  getHelp: 'get_help',
  viewCookbookRecipe: 'view_cookbook_recipe',
} as const

export const RESUBSCRIBE_URL = `${clientRoutes.mySubscription}?view=resubscribe`
